import type { IconData } from '@stacksjs/iconify-core'

export const ws1x1: IconData = {
  "body": "<g fill-rule=\"evenodd\" stroke-width=\"1pt\"><path fill=\"#ce1126\" d=\"M0 0h512v512H0z\"/><path fill=\"#002b7f\" d=\"M0 0h256v256H0z\"/><path fill=\"#fff\" d=\"m147 231.4l-19.6-13.3l-18.9 13.5l6-23.5l-18-14.7l23.2-1.3l7.7-22.4l8.5 22.8l22.8.5l-18.2 15.5zm-3.4-156.8l-15.6-10l-15.4 10l4.2-19l-13.7-12.1l18.3-1.6l6.8-17.5l7.1 17.7l18 1.4l-14 12.5zM74.3 131l-15.2-10.8l-15.4 10.4l4.6-18.3L34 100.2l18.2-.8l6.7-18.1l6.6 17.8l18.3 1.1l-14.3 12zm139-12.7l-14.7-9.5l-14.3 9.7l4-17.4l-13-11.2l17.3-1.4l6-16.4l6.6 16.6l16.8 1l-13.2 11.6zm-41.1 41.3l-9.7-6.2l-9.6 6.2l2.5-11.6l-8.7-7.7l11.4-1l4.4-11l4.5 11l11.2 1l-8.5 7.7z\"/></g>",
  "width": 512,
  "height": 512,
  "viewBox": "0 0 512 512"
}

export default ws1x1
